// export const GET_GLOBAL_DATA = 'campaign/GlobalCampaignV2';

export const GET_GLOBAL_DATA = 'campaign/GlobalCampaignV2';
export const GET_BANNER_SETTINGS = 'campaign/setting';
export const GET_CONTENT_CAMPAIGN_DATA = 'campaign/contentCampaignV2';
export const EXCLUDE_CAMPAIGN = 'campaign/excludeCampaign';
export const ADD_BANNER_REPORT = process.env.REACT_APP_BANNER_REPORTING_ENDPOINT;
